import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const NotFound = () => {
    const { me } = useAuth();

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="text-center max-w-md p-8 bg-white rounded-lg shadow-md">
                <h2 className="text-3xl font-bold text-gray-900 mb-2">Page Not Found</h2>
                <p className="text-gray-600 mb-6">Sorry, we couldn't find the page you're looking for.</p>

                <div className="flex flex-col space-y-2">
                    {me ? (
                        <Link
                            to="/dashboard"
                            className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition duration-200"
                        >
                            Go to Dashboard
                        </Link>
                    ) : (
                        <Link
                            to="/login"
                            className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition duration-200"
                        >
                            Go to Login
                        </Link>
                    )}

                    <button
                        onClick={() => window.history.back()}
                        className="bg-gray-200 text-gray-800 py-2 px-4 rounded hover:bg-gray-300 transition duration-200"
                    >
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    );
};